import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';

import { environment } from "../../environments/environment";
import { BehaviorSubject } from 'rxjs';
// import { setTimeout } from 'timers';

@Injectable()
export class AlertService {
    private data:any;
    private response=[];
    private alert = new BehaviorSubject<string>('');
    alerts = this.alert.asObservable();
    constructor(private http: HttpClient) { };
    public getAlert() {
        const alertObservable = new Observable(observer => {
            this.data = this.response;
            if(this.response.length > 0){
                this.alert.next(this.data);
                observer.next(this.data);
            }else{
                this.alert.next(this.data);
                observer.next(this.data);
            }
        });
        return alertObservable; 
    } // get notification end*/
    public updateAlert(data) {
        const updateAlertObservable = new Observable(observer => {
            this.response.push(data);
            this.data = this.response;
            if(this.data.length > 0){
                this.alert.next(this.data);
                observer.next(this.data);
            }else{
                this.data = this.response;
                this.alert.next(this.data);
                observer.next(this.data);
            }
            
        });
        return updateAlertObservable; 
    } // get notification end*/
    public deleteAlert() {
        const deleteAlertObservable = new Observable(observer => {
            //this.data = this.response.slice(1);
            this.response = [];
            this.data = this.response;
            this.alert.next(this.data);
            observer.next(this.data);
        });
        return deleteAlertObservable; 
    } // get notification end*/
} // class